<div class="arguments-wrapper">
  @if (
    showFavoriteArgumentsStatus() && !productArgumentsGroupedByCategory().length
  ) {
    <claas-empty-favorites-list [isAppPanel]="true">
      <div class="empty-favorites-info">
        <h1 class="empty-favorites-title font-3xl">
          {{ "features.emptyFavoritesList.emptyFavoritesTitle" | translate }}
        </h1>
        <p class="empty-favorites-text font-m">
          {{
            "features.emptyFavoritesList.emptyFavoritesDocuments.emptyFavoritesText"
              | translate
          }}
        </p>
        <p class="empty-favorites-text font-m">
          {{
            "features.emptyFavoritesList.emptyFavoritesDocuments.emptyFavoritesTextCta"
              | translate
          }}
        </p>
      </div>
      <div class="favorites-toggle-wrapper">
        <claas-toggle
          id="toggle-button"
          class="favorites-toggler"
          [disabled]="false"
          [label]="'pia.shared.toggleFavouritesButtonLabel' | translate"
          [checked]="!!showFavoriteArgumentsStatus()"
          [required]="false"
          [disableRipple]="true"
          [inputTop]="false"
          [size]="toggleSize.SMALL"
          [truncatedText]="true"
          (changed)="handleToggleFavouriteArgumentsChange($event)"
        ></claas-toggle>
      </div>
    </claas-empty-favorites-list>
  } @else {
    <div class="controls">
      <claas-toggle
        id="toggle-button"
        class="favorites-toggler"
        [disabled]="false"
        [label]="'pia.shared.toggleFavouritesButtonLabel' | translate"
        [checked]="!!showFavoriteArgumentsStatus()"
        [required]="false"
        [disableRipple]="true"
        [inputTop]="false"
        [size]="toggleSize.SMALL"
        [truncatedText]="true"
        (changed)="handleToggleFavouriteArgumentsChange($event)"
      ></claas-toggle>
    </div>
    @for (
      productArgumentsGroup of productArgumentsGroupedByCategory();
      track productArgumentsGroup
    ) {
      <details class="accordion" open>
        <summary class="argument-group-summary">
          <h3 class="argument-group-title font-m">
            {{ productArgumentsGroup.title }}
          </h3>
          <claas-icon
            class="arrow-icon"
            [iconId]="'659460'"
            [namespace]="'pia'"
            [size]="24"
            [alt]="''"
            [removeDefaultColor]="true"
          >
          </claas-icon>
        </summary>
        <ul class="argument-list">
          @for (
            productArgument of productArgumentsGroup.items;
            track productArgument.ID
          ) {
            <claas-product-argument-row
              (expandArgumentDetail)="setShowMainModal(true)"
              [productArgument]="productArgument"
            ></claas-product-argument-row>
          }
        </ul>
      </details>
    }
  }
  <claas-main-modal-dialog
    [(show)]="showMainModal"
    [navigateOnBackdropClick]="`/pia/${countryID}/${languageID}/${year}/product/${productID}/arguments/${productDetailID}`"
  >
    <router-outlet></router-outlet
  ></claas-main-modal-dialog>
</div>
